// libs
import { styled } from '@nykaa/ui-components';

// components
import IOElement from 'shared/components/IOElement';

// constants
import { BREAKPOINTS } from 'shared/styles/base';
import { truncate } from 'shared/styles/mixin';

export const HeaderContainer = styled(IOElement)`
  position: relative;
  height: 40px;
  ${({ theme }) => theme.typography.type241};
  display: flex;
  align-items: center;

  max-width: ${BREAKPOINTS.DESKTOP}px;
  ${({ theme }) => `margin:${theme.spacing.spacing200}`} auto;
`;

export const Placeholder = styled.div`
  ${({ theme }) =>
    `margin: 0 ${theme.spacing.spacing100} ${theme.spacing.spacing40} ${theme.spacing.spacing100}`};
  width: 100%;
  height: 40px;
`;
export const Title = styled.h1`
  ${truncate};
  position: relative;

  ${({ theme }) => theme.typography.titleLarge};

  .count {
    ${({ theme }) => theme.typography.bodyMedium};
    color: ${({ theme }) => theme.colors.textSecondary};

    .seperator {
      display: inline-block;
      width: 4px;
      height: 4px;
      border-radius: ${({ theme }) => theme.borders.radiusFull};
      background-color: ${({ theme }) => theme.colors.textOutline};
      ${({ theme }) =>
        `margin: 0 ${theme.spacing.spacing20} ${theme.spacing.spacing20} ${theme.spacing.spacing40}`};
    }
  }
`;

export const AppHeaderContent = styled.div`
  flex: 1;
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ theme }) => theme.typography.titleMedium};
  ${({ theme }) => `padding-left: ${theme.spacing.spacing100}`};

  .count {
    ${({ theme }) => theme.typography.bodySmall};
    color: ${({ theme }) => theme.colors.textSecondary};

    .seperator {
      display: inline-block;
      width: 4px;
      height: 4px;
      border-radius: ${({ theme }) => theme.borders.radiusFull};
      background-color: ${({ theme }) => theme.colors.textOutline};
      ${({ theme }) =>
        `margin: 0 ${theme.spacing.spacing40} ${theme.spacing.spacing40} ${theme.spacing.spacing40}`};
    }
  }
`;
